export default {"src":"/_next/static/media/sort.6d2b9dd5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};